import {Component} from '@angular/core';
import {AgeSexPipe} from "../../../lib/age-sex.pipe";
import {DatePipe} from "@angular/common";
import {MatButtonModule} from "@angular/material/button";
import {OrgDatePipe} from "@allaihealth/ng-platform";
import {RouterLink} from "@angular/router";
import {MatIconModule} from "@angular/material/icon";
import {BasePatientPage} from "../base-patient-page";

/** Top bar on patient page that shows details on the patient and appointment */
@Component({
	selector: 'app-patient-details',
	imports: [
		AgeSexPipe,
		DatePipe,
		MatButtonModule,
		MatIconModule,
		OrgDatePipe,
		RouterLink
	],
	templateUrl: './patient-details.component.html',
	styleUrl: './patient-details.component.scss'
})
export class PatientDetailsComponent extends BasePatientPage {
}
